<template>

  <Head>
    <title>Create New Order | NutriStudents K-12</title>
    <meta name="description" content="Create New Order" />
  </Head>
  <default-layout>
    <BreadcrumLayout>
      <U>Tools</U>
    </BreadcrumLayout>
    <PageTitleLayout>
      <div class="lg:mb-0 mb-4 w-full">
        <h1 class="heading-color xl:text-4xl text-2xl font-bold">
          Step 1: Build Your Order
        </h1>
      </div>
      <div class="w-full flex lg:flex-nowrap flex-wrap justify-end items-center"></div>
    </PageTitleLayout>

    <div class="relative z-50 xl:flex w-full xl:px-10 px-5 xl:pt-10 pt-5 mb-5 justify-between items-end">
      <div class="sm:flex flex-wrap items-end">
        <div class="relative focus:outline-none lg:w-72 sm:w-1/2 w-full px-3 xl:mt-0 mb-4 lg:mb-0 ml-0">
          <label for="" class="font-bold text-black-800 text-sm uppercase">Date</label>
          <div
            class="col-6 p-2 border col-md-auto m-auto flex justify-between cursor-pointer relative bg-white rounded-lg overflow-hidden"
            @click="showCalendar()">
            {{ selectedDate[0].format("DD MMM, YYYY") }} -
            {{ selectedDate[1].format("D MMM, YYYY") }}
            <i style="display: flex"
              class="fa fa-calendar absolute top-0 right-0 bg-[#39b54a] w-[40px] h-[40px] justify-center items-center text-white"></i>
          </div>
          <div class="row mt-1 border absolute left-0 bg-white z-10" v-show="show.calendar">
            <DatePicker :lastMonth="true" v-model="selectedDate" @onSelect="showCalendar" @onCancel="showCalendar"
              :next-prev-icon="true" :last-month="todayDt" :first-month="firstDt" :enableSecondCalendar="true" />
          </div>
        </div>


        <div class="relative z-40 focus:outline-none lg:w-52 sm:w-1/2  px-3 xl:mt-0 mb-4 lg:mb-0 ml-0 flex gap-10 ">
          <div class="relative max-w-[100%] min-w-full" v-click-outside="closeSite">
            <label for="" class="font-bold text-black-800 text-sm mb-1 block uppercase">Site/Group Offerings</label>
            <div @click="showSite = !showSite"
              class="cursor-pointer pr-2 font-normal text-black-800 text-sm flex justify-start items-start gap-x-2.5 ">
              <div if="form.offer.length == 0" class="border p-2.5 bg-white">Select Site/Offering <i
                  class="fa fa-chevron-down ml-1" aria-hidden="true"></i></div>

            </div>

            <div v-if="showSite"
              class="max-h-60 overflow-y-scroll absolute top-16 left-0 min-w-[280px] bg-white p-4 list-none">
              <label>
                <input type="checkbox" v-model="sitesOfferingsSelectAll" @change="toggleSitesOfferingsSelectAll" />
                Select All
              </label>

              <!-- Sites List -->
              <ul style="list-style:none; margin-left: 1rem;">
                <li v-for="(site, index) in sitesOfferingsList" :key="index">
                  <label>
                    <span class="inline-flex items-center justify-center w-5 h-5 border-2 border-gray-600 cursor-pointer select-none rounded text-sm font-bold text-[#39b54a] ">
                      <i
    v-if="site.selected"
    class="fa fa-solid fa-check block"
  ></i>

  <i
    v-else-if="site.is_selected_count > 0"
    class="fa fa-solid fa-minus block relative top-[2px]"
  ></i>
                      
                      <!-- {{ site.selected ? '✔️' : (site.is_selected_count > 0 ? '➖' : '') }} -->
                    
                    </span>
                    
                    <input class="hidden" type="checkbox" v-model="site.selected" @change="toggleSitesOfferingSite(site)" />
                    {{ site.name }}
                    <button v-if="site.offerings?.length" @click="site.expanded = !site.expanded"
                      style="border:none;background:none;cursor:pointer;">
                      {{ site.expanded ? '▲' : '▼' }}
                    </button>
                  </label>

                  <!-- Offerings -->
                  <ul v-if="site.expanded && site.offerings.length" style="list-style:none; margin-left: 1.5rem;">
                    <li v-for="(offering, oIndex) in site.offerings" :key="oIndex">
                      <label>
                        <input type="checkbox" v-model="offering.selected" @change="toggleSitesOfferingItem(site)" />
                        {{ offering.name }}
                      </label>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>


        <button class="button-color text-white font-bold py-2 rounded px-3 md:mt-0 mt-4 whitespace-nowrap inline-block max-w-max disabled:cursor-not-allowed uppercase" @click="getDateRecipeData">Update</button>
        <button class="button-color text-white font-bold py-2 rounded px-3 md:mt-0 mt-4 whitespace-nowrap inline-block max-w-max disabled:cursor-not-allowed uppercase ml-2" @click="cancelSearch">Cancel</button>

        <a href="javascript:void(0)" @click="resetSeatch" class="flex items-center ml-2">
          <img :src="$page.props.asset_url + '/images/clear-filter.png'" class="w-[28px]" /></a>
      </div>

    </div>




    <!-- <div v-if="form.offer.length > 0" class="flex justify-start gap-[5px] flex-wrap z-40 w-full xl:px-10 px-5 mb-5">
            <div class="normal-case bg-[#39b54a] text-white px-3 py-1 rounded-[8px] font-normal"
              v-for="offerId in form.offer">{{ showOfferName(offerId) }}
              <span class="ml-2 cursor-pointer hover:text-red-600" @click="removeOffering(offerId)">&times;</span>
            </div>
          </div> -->


    <TableIndexLayout>
      <div class="-my-2 mb-0">
        <div class="py-2 align-middle inline-block xl:px-10 px-5 w-full pb-0">
          <button type="button"
            class="button-color uppercase text-white font-bold py-3 rounded px-4 md:mt-0 mt-4 whitespace-nowrap max-w-max w-fit mx-auto mr-0 block mb-4"
            v-if="isAvailableToSendTable2" @click="setOnTable2()">
            Send to Selected Recipes
          </button>
          <div class="shadow mb-10 overflow-auto">
            <table class="min-w-full">
              <thead class="header-bg-color">
                <tr class="bg-blue-nutri">
                  <th scope="col"
                    class="id_arrow px-6 py-3 text-left text-base font-bold text-white uppercase tracking-wider relative">
                    <input type="checkbox" v-model="selectAll" :checked="areAllChecked(searchResults)"
                      @change="selectAllRecipe">
                  </th>
                  <th scope="col"
                    class="id_arrow px-6 py-3 text-left text-base font-bold text-white uppercase tracking-wider relative">
                    Date of Order
                  </th>
                  <th scope="col" class="px-6 py-3 text-left text-base font-bold text-white uppercase tracking-wider">
                    Recipe Name
                  </th>
                  <th scope="col"
                    class="text-center px-6 py-3  text-base font-bold text-white uppercase tracking-wider">
                    Planned Headcount
                  </th>
                  <th scope="col" class="px-6 py-3 text-left text-base font-bold text-white uppercase tracking-wider">
                    Override Headcount
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!getDateRecipe && searchResults.length == 0" class="bg-white">
                  <td class="px-6 py-4 whitespace-nowrap text-base text-color text-center" colspan="7">
                    Please select date, site/offering
                  </td>
                </tr>

                <tr v-if="getDateRecipe && searchResults.length == 0" class="bg-white">
                  <td class="px-6 py-4 whitespace-nowrap text-base text-color text-center" colspan="7">
                    No Record Found
                  </td>
                </tr>

                <template v-for="(recipesByDate, date) in groupedByDate" :key="date">
                  <!-- Date Header -->
                  <tr class="bg-[#ededed] cursor-pointer hover:bg-gray-200" @click="toggleDate(date)">
                    <td colspan="5" class="px-6 py-3 font-bold text-left">
                      {{ date }}
                      <span class="float-right text-gray-600">
                        <span v-if="collapsedDates.includes(date)">&#9654;</span>
                        <span v-else>&#9660;</span>
                      </span>
                    </td>
                  </tr>

                  <!-- Recipes inside the Date -->
                  <template v-if="!collapsedDates.includes(date)">
                    <template v-for="(offerGroups, recipeName) in recipesByDate" :key="recipeName">
                      <template
                        v-if="Object.keys(offerGroups).length === 1 && Object.values(offerGroups)[0].length === 1">
                        <template v-for="(items, offeringName) in offerGroups" :key="offeringName">
                          <tr class="bg-white">
                            <td class="text px-6 py-4">
                              <input type="checkbox" v-model="items[0].is_chekcked" />
                            </td>
                            <td class="text px-6 py-4"></td>
                            <td class="text px-6 py-4">
                              <a v-if="items[0].recipe_id" :href="route('recipes-edit', [items[0].recipe_id])"
                                target="_blank" class="underline id-color">
                                {{ recipeName }} 
                              </a> :
                              {{ getRecipeSiteOfferName(items[0]) }}
                              <b v-if="items[0].duplicate > 1"> X {{ items[0].duplicate }}</b>
                            </td>
                            <td class="text px-6 py-4 text-center">
                              {{ items[0].yield_portion }}
                            </td>
                            <td class="text px-6 py-4">
                              <input type="number" min="0" v-model="items[0].override_yield_portion"
                                class="shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md w-18-input mr-4" />
                            </td>
                          </tr>
                        </template>
                      </template>

                      <template v-else-if="Object.keys(offerGroups).length === 1">
                        <template v-for="(items, offeringName) in offerGroups" :key="offeringName">
                          <!-- Offer Header -->
                          <tr class="bg-blue-50  hover:bg-blue-100">
                            <td class="text px-6 py-4">
                              <input type="checkbox" :checked="areAllChecked(items)"
                                @change="toggleAllRecipeSiteOfferingItems(items, $event)" />
                            </td>
                            <td class="text px-6 py-4"></td>
                            <td class="pxa-10 py-2 font-semibold text-left cursor-pointer"
                              @click="toggleRecipeSiteOfferings(date, recipeName, offeringName)">
                              <a target="_blank" v-if="items[0].recipe_id"
                                :href="route('recipes-edit', [items[0].recipe_id])" class="underline id-color">
                                {{ getRecipeName(items[0].type_number, items[0].name) }}
                                <span class="text-gray-500 ml-2">({{ items.length }})</span>
                              </a>
                              <span class="ml-2 text-gray-600">
                                <span
                                  v-if="isRecipeSiteOfferingCollapsed(date, recipeName, offeringName)">&#9654;</span>
                                <span v-else>&#9660;</span>
                              </span>
                            </td>
                            <td class="text px-6 py-4 text-center">
                              {{ totalYield(items, 'yield_portion') }}
                            </td>
                            <td class="text px-6 py-4 text-center">
                              {{ totalYield(items, 'override_yield_portion') }}
                            </td>
                          </tr>
                          <!-- Items -->
                          <tr v-show="!isRecipeSiteOfferingCollapsed(date, recipeName, offeringName)"
                            v-for="sresult in items" :key="sresult.oc_id" class="bg-white">
                            <td class="text px-10 py-4">
                              <input type="checkbox" v-model="sresult.is_chekcked" />
                            </td>
                            <td class="text px-6 py-4"></td>
                            <td class="text px-6 py-4 pl-8">
                              <!-- {{ getRecipeName(sresult.type_number, sresult.name) }} -->
                              {{ getRecipeSiteOfferName(sresult, true) }} 
                              <b v-if="sresult.duplicate > 1"> X {{ sresult.duplicate }}</b>
                            </td>
                            <td class="text px-6 py-4 text-center">
                              {{ sresult.yield_portion }}
                            </td>
                            <td class="text px-6 py-4">
                              <input type="number" min="0" v-model="sresult.override_yield_portion"
                                class="shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md w-18-input mr-4" />
                            </td>
                          </tr>
                        </template>
                      </template>
                      <template v-else>
                        <tr class="bg-blue-50  hover:bg-blue-100">
                          <td class="text px-6 py-4">
                            <input type="checkbox" :checked="areAllRecipeItemsChecked(offerGroups)"
                              @change="toggleAllRecipeItems(offerGroups, $event)" />
                          </td>
                          <td class="text px-6 py-4">
                           
                          </td>
                          <td class="pxa-10 py-2 font-semibold text-left cursor-pointer"
                            @click="toggleRecipe(date, recipeName)">
                            <a target="_blank" v-if="getFirstRecipeId(offerGroups)"
                              :href="route('recipes-edit', [getFirstRecipeId(offerGroups)])" class="underline id-color">
                              {{ recipeName }}
                            </a>
                            <span class="text-gray-500 ml-2">({{ totalItemsInOfferGroups(offerGroups) }})</span>
                            <span class="ml-2 text-gray-600">
                              <span v-if="isRecipeCollapsed(date, recipeName)">&#9654;</span>
                              <span v-else>&#9660;</span>
                            </span>
                          </td>
                          <td class="text px-6 py-4 text-center">
                            {{ totalRecipeYield(offerGroups, 'yield_portion') }}
                          </td>
                          <td class="text px-6 py-4 text-center">
                            {{ totalRecipeYield(offerGroups, 'override_yield_portion') }}
                          </td>
                        </tr>
                        <template v-if="!isRecipeCollapsed(date, recipeName)">
                          <template v-for="(items, offeringName) in offerGroups" :key="offeringName">
                          <template  v-if="items.length ==1">
                            <!-- <tr class="bg-[#ededed]">
                              <td class="text px-10 py-4">
                                <input type="checkbox" :checked="areAllChecked(items)"
                                  @change="toggleAllRecipeSiteOfferingItems(items, $event)" />
                              </td>
                              <td class="text px-6 py-4">
                                else-1 {{ items.length }}
                              </td>
                              <td class="text px-6 py-4 pxa-10 font-semibold text-left cursor-pointer"
                                @click="toggleRecipeSiteOfferings(date, recipeName, offeringName)">
                                {{ offeringName }}
                                <span class="text-gray-500 ml-2">({{ Object.keys(items).length }})</span>

                                <span class="ml-2 text-gray-600">
                                  <span
                                    v-if="isRecipeSiteOfferingCollapsed(date, recipeName, offeringName)">&#9654;</span>
                                  <span v-else>&#9660;</span>
                                </span>

                              </td>
                              <td class="text px-6 py-4 text-center">
                                {{ totalYield(items, 'yield_portion') }}
                              </td>
                              <td class="text px-6 py-4 text-center">
                                {{ totalYield(items, 'override_yield_portion') }}
                              </td>
                            </tr> -->
                            <tr show="!isRecipeSiteOfferingCollapsed(date, recipeName, offeringName)"
                              v-for="sresult in items" :key="sresult.id" class="bg-[#ededed]">
                              <td class="text px-14 py-4">
                                <input type="checkbox" v-model="sresult.is_chekcked" />
                              </td>
                              <td class="text px-16 py-4">
                              </td>
                              <td class="text px-16 py-4">
                                <!-- {{ getRecipeName(sresult.type_number, sresult.name) }} -->
                                {{ getRecipeSiteOfferName(sresult) }} 
                                <b v-if="sresult.duplicate > 1"> X {{ sresult.duplicate }}</b>
                              </td>
                              <td class="text px-16 py-4 text-center">
                                {{ sresult.yield_portion }}
                              </td>
                              <td class="text px-16 py-4">
                                <input type="number" min="0" v-model="sresult.override_yield_portion"
                                  class="shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md w-18-input mr-4" />
                              </td>
                            </tr>
                          </template>
                          </template>
                          <template v-for="(items, offeringName) in offerGroups" :key="offeringName">
                          <template v-if="items.length > 1">
                            <tr class="bg-[#ededed]">
                              <td class="text px-10 py-4">
                                <input type="checkbox" :checked="areAllChecked(items)"
                                  @change="toggleAllRecipeSiteOfferingItems(items, $event)" />
                              </td>
                              <td class="text px-6 py-4">
                                
                              </td>
                              <td class="text px-6 py-4 pxa-10 font-semibold text-left cursor-pointer"
                                @click="toggleRecipeSiteOfferings(date, recipeName, offeringName)">
                                {{ offeringName }}
                                <span class="text-gray-500 ml-2">({{ Object.keys(items).length }})</span>

                                <span class="ml-2 text-gray-600">
                                  <span
                                    v-if="isRecipeSiteOfferingCollapsed(date, recipeName, offeringName)">&#9654;</span>
                                  <span v-else>&#9660;</span>
                                </span>

                              </td>
                              <td class="text px-6 py-4 text-center">
                                {{ totalYield(items, 'yield_portion') }}
                              </td>
                              <td class="text px-6 py-4 text-center">
                                {{ totalYield(items, 'override_yield_portion') }}
                              </td>
                            </tr>
                            <tr v-show="!isRecipeSiteOfferingCollapsed(date, recipeName, offeringName)"
                              v-for="sresult in items" :key="sresult.id" class="bg-[#ededed]">
                              <td class="text px-14 py-4">
                                <input type="checkbox" v-model="sresult.is_chekcked" />
                              </td>
                              <td class="text px-16 py-4">
                              </td>
                              <td class="text px-16 py-4">
                                <!-- {{ getRecipeName(sresult.type_number, sresult.name) }} -->
                                {{ getRecipeSiteOfferName(sresult) }} 
                                <b v-if="sresult.duplicate > 1"> X {{ sresult.duplicate }}</b>
                              </td>
                              <td class="text px-16 py-4 text-center">
                                {{ sresult.yield_portion }}
                              </td>
                              <td class="text px-16 py-4">
                                <input type="number" min="0" v-model="sresult.override_yield_portion"
                                  class="shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md w-18-input mr-4" />
                              </td>
                            </tr>
                          </template>
                          </template>


                        </template>
                      </template>
                    </template>
                  </template>
                </template>

              </tbody>
            </table>
          </div>
        </div>
      </div>
    </TableIndexLayout>


    <TableIndexLayout>
      <div class="-my-2 mb-0 py-2 align-middle inline-block xl:px-10 px-5 w-full pb-0">

        <div class="flex justify-between gap-2.5 mb-4">
          <span class="text-left text-base font-bold text-black-800 uppercase">Selected Recipes </span>
          <button type="button" @click="pushOrder()" :disabled="searchTableResults.length == 0"
            class="button-color text-white font-bold py-2 rounded px-4 md:mt-0 mt-4 whitespace-nowrap inline-block max-w-max disabled:cursor-not-allowed uppercase disabled:opacity-50">
            Next >
          </button>
        </div>

        <div class="flex justify-flex-start gap-2.5 mb-4">
          <button type="button" :disabled="searchTableResults.length == 0"
            class="button-color text-white font-bold py-2 rounded px-4 md:mt-0 mt-4 whitespace-nowrap inline-block max-w-max disabled:cursor-not-allowed uppercase"
            @click="exportToCSV()">
            Export Entries
          </button>

          <button type="button" @click="triggerFileUpload" :disabled="searchTableResults.length == 0"
            class="button-color text-white font-bold py-2 rounded px-4 md:mt-0 mt-4 whitespace-nowrap inline-block max-w-max disabled:cursor-not-allowed uppercase">
            Import Headcounts
          </button>
          <!-- <div>
            Import Headcounts -->
          <input type="file" @change="importCSV" ref="fileInput" accept=".csv" style="display: none;" />
          <!-- </div>  -->



          <div class="relative md:w-96">
            <input
              class="border-2 border-gray-300 bg-white h-10 px-3 pr-10 rounded-lg text-sm focus:outline-none w-full"
              v-model="form.name" @input="
                recipeSearchData" type="search" name="searchByName" placeholder="Search Recipe">
            <button type="submit" class="absolute right-0 top-0 mt-2 mr-4 outline-none" @click="recipeSearchData"><i
                class="fa fa-search" aria-hidden="true"></i></button>

            <div class="
          absolute
          bg-white
          max-w-2xl
          overflow-y-auto
          w-full
          max-h-48
          z-10
        ">
              <div v-for="searched_recipe in searched_recipes" class="py-1 px-3 cursor-pointer hover:bg-gray-100"
                @click="selectRecipesIdToAdd(searched_recipe)">
                {{ searched_recipe.name
                }}
              </div>
            </div>
          </div>




        </div>




        <div class="py-2 align-middle inline-block w-full pb-0">
          <div class="shadow mb-10 overflow-auto">
            <table class="min-w-full">
              <thead class="header-bg-color">
                <tr class="bg-blue-nutri">

                  
                  <th scope="col" class="px-6 py-3 text-left text-base font-bold text-white uppercase tracking-wider">
                    Recipe Name
                  </th>
                  <th scope="col"
                    class="id_arrow px-6 py-3 text-left text-base font-bold text-white uppercase tracking-wider relative">
                    Date of Order
                  </th>
                  <th scope="col"
                    class="text-center px-6 py-3  text-base font-bold text-white uppercase tracking-wider">
                    Planned Headcount
                  </th>
                  <th scope="col"
                    class="text-center px-6 py-3  text-base font-bold text-white uppercase tracking-wider">
                    Override Headcount
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody v-if="searchTableResults.length > 0">

                <!-- <template v-for="(recipesByDate, date) in groupedByDateSelected" :key="'select'+date"> -->
                <!-- Date Header -->
                <!-- <tr class="bg-[#ededed] cursor-pointer hover:bg-gray-200" @click="toggleDateSelected(date)">
        <td colspan="5" class="px-6 py-3 font-bold text-left">
          {{ date }}
          <span class="float-right text-gray-600">
            <span v-if="collapsedDatesSelected.includes(date)">&#9654;</span>
            <span v-else>&#9660;</span>
          </span>
        </td>
      </tr> -->

                <!-- Recipes inside the Date -->
                <!-- <template v-if="!collapsedDatesSelected.includes(date)"> -->
                <template v-for="(offerGroups, recipeName) in groupedByRecipeSelected" :key="recipeName">
                  <template v-if="Object.keys(offerGroups).length === 1 && Object.values(offerGroups)[0].length === 1">
                    <template v-for="(items, offeringName) in offerGroups" :key="offeringName">
                      <tr class="bg-white">
                        
                        <td class=" px-6 py-2 font-semibold text-left cursor-pointer">
                          <a target="_blank" v-if="items[0].recipe_id"
                            :href="route('recipes-edit', [items[0].recipe_id])" class="underline id-color">
                            {{ recipeName }} : ({{ getRecipeSiteOfferName(items[0]) }}) 
                          </a>
                           <b v-if="items[0].duplicate > 1"> X {{ items[0].duplicate }}</b>
                        </td>
                        <td class="text px-6 py-4">
                          {{ convertDate(items[0].date) }}
                                </td>
                        <td class="text px-6 py-4 text-center">
                          {{ items[0].yield_portion }}
                        </td>
                        <td class="text px-6 py-4">
                          <input type="number" min="0" v-model="items[0].override_yield_portion"
                            class="shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md w-18-input mr-4" />
                        </td>
                        <td class="px-14 py-4 whitespace-nowrap font-bold underline id-color text-2xl">
                          <button @click="removeRecipeFromOrderSelection(items[0])" class="pl-3">
                            <i class="fa fa-trash" aria-hidden="true"></i>
                          </button>
                        </td>
                      </tr>
                    </template>
                  </template>
                  <template v-else-if="Object.keys(offerGroups).length === 1">
                    <template v-for="(items, offeringName) in offerGroups" :key="offeringName">
                      <tr class="bg-blue-50  hover:bg-blue-100">
                        <!-- <td class="text px-6 py-4">
                        </td> -->
                        <td class="px-6 py-2 font-semibold text-left cursor-pointer"
                          @click="toggleRecipeSiteOfferingsSelected(date, recipeName, offeringName)">
                          <a target="_blank" v-if="items[0].recipe_id"
                            :href="route('recipes-edit', [items[0].recipe_id])" class="underline id-color">
                            {{ recipeName }}
                          </a>
                          <span class="text-gray-500 ml-2">({{ items.length }})</span>
                          <span class="ml-2 text-gray-600">
                            <span
                              v-if="isRecipeSiteOfferingCollapsedSelected(date, recipeName, offeringName)">&#9654;</span>
                            <span v-else>&#9660;</span>
                          </span>
                        </td>
                        <td>&nbsp;</td>
                        <td class="text px-6 py-4 text-center">
                          {{ totalYield(items, 'yield_portion') }}
                        </td>
                        <td class="text px-6 py-4 text-center">
                          {{ totalYield(items, 'override_yield_portion') }}
                        </td>
                        <td class="px-6 py-4 whitespace-nowrap font-bold underline id-color text-2xl">
                        </td>
                      </tr>

                      <tr v-show="!isRecipeSiteOfferingCollapsedSelected(date, recipeName, offeringName)"
                        v-for="sresult in items" :key="sresult.id" class="bg-[#ededed]">
                        <!-- <td class="text px-16 py-4">
                            </td> -->
                        <td class="text px-16 py-4">
                          {{ getRecipeSiteOfferName(sresult, true) }} 
                          <b v-if="sresult.duplicate > 1"> X {{ sresult.duplicate }}</b>
                        </td>
                        <td class="text px-16 py-4">
                          {{ convertDate(sresult.date) }}
                            </td>
                        <td class="text px-16 py-4 text-center">
                          {{ sresult.yield_portion }}
                        </td>
                        <td class="text px-16 py-4">
                          <input type="number" min="0" v-model="sresult.override_yield_portion"
                            class="shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md w-18-input mr-4" />
                        </td>
                        <td class="px-14 py-4 whitespace-nowrap font-bold underline id-color text-2xl">
                          <button @click="removeRecipeFromOrderSelection(sresult)" class="pl-3">
                            <i class="fa fa-trash" aria-hidden="true"></i>
                          </button>
                        </td>
                      </tr>

                    </template>
                  </template>
                  <template v-else>
                    <tr class="bg-blue-50  hover:bg-blue-100">
                      <!-- <td class="text px-6 py-4">
                    </td> -->
                      <td class="px-6 py-2 font-semibold text-left cursor-pointer"
                        @click="toggleRecipeSelected(date, recipeName)">
                        <a target="_blank" v-if="getFirstRecipeId(offerGroups)"
                          :href="route('recipes-edit', [getFirstRecipeId(offerGroups)])" class="underline id-color">
                          {{ recipeName }}
                        </a>
                        <span class="text-gray-500 ml-2">({{ totalItemsInOfferGroups(offerGroups) }})</span>
                        <span class="ml-2 text-gray-600">
                          <span v-if="isRecipeCollapsedSelected(date, recipeName)">&#9654;</span>
                          <span v-else>&#9660;</span>
                        </span>
                      </td>
                      <td>&nbsp;</td>
                      <td class="text px-6 py-4 text-center">
                        {{ totalRecipeYield(offerGroups, 'yield_portion') }}
                      </td>
                      <td class="text px-6 py-4 text-center">
                        {{ totalRecipeYield(offerGroups, 'override_yield_portion') }}
                      </td>
                      <td class="px-6 py-4 whitespace-nowrap font-bold underline id-color text-2xl">
                      </td>
                    </tr>
                    <template v-if="!isRecipeCollapsedSelected(date, recipeName)">
                      <template v-for="(items, offeringName) in offerGroups" :key="offeringName">
                        <template v-if="items.length == 1">
                        <!-- <tr class="bg-[#ededed]">
                          <td class="text px-6 py-4 font-semibold text-left cursor-pointer"
                            @click="toggleRecipeSiteOfferingsSelected(date, recipeName, offeringName)">
                            {{ offeringName }}
                            <span class="text-gray-500 ml-2">({{ Object.keys(items).length }})</span>
                            <span class="ml-2 text-gray-600">
                              <span
                                v-if="isRecipeSiteOfferingCollapsedSelected(date, recipeName, offeringName)">&#9654;</span>
                              <span v-else>&#9660;</span>
                            </span>
                          </td>
                          <td class="text px-6 py-4 text-center">
                            {{ totalYield(items, 'yield_portion') }}
                          </td>
                          <td class="text px-6 py-4 text-center">
                            {{ totalYield(items, 'override_yield_portion') }}
                          </td>
                          <td class="px-6 py-4 whitespace-nowrap font-bold underline id-color text-2xl">
                          </td>
                        </tr> -->

                        <tr show="!isRecipeSiteOfferingCollapsedSelected(date, recipeName, offeringName)"
                          v-for="sresult in items" :key="sresult.id" class="bg-[#ededed]">
                          <!-- <td class="text px-16 py-4">
                            </td> -->
                          <td class="text px-16 py-4">
                            {{ getRecipeSiteOfferName(sresult) }} 
                            <b v-if="sresult.duplicate > 1"> X {{ sresult.duplicate }}</b>
                          </td>
                          <td class="text px-16 py-4">
                            {{ convertDate(sresult.date) }}
                          </td>
                          
                          <td class="text px-16 py-4 text-center">
                            {{ sresult.yield_portion }}
                          </td>
                          <td class="text px-16 py-4">
                            <input type="number" min="0" v-model="sresult.override_yield_portion"
                              class="shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md w-18-input mr-4" />
                          </td>
                          <td class="px-14 py-4 whitespace-nowrap font-bold underline id-color text-2xl">
                            <button @click="removeRecipeFromOrderSelection(sresult)" class="pl-3">
                              <i class="fa fa-trash" aria-hidden="true"></i>
                            </button>
                          </td>
                        </tr>
                        </template>
                        <template v-if="items.length > 1">
                        <tr class="bg-[#ededed]">
                          <td class="text px-6 py-4 font-semibold text-left cursor-pointer"
                            @click="toggleRecipeSiteOfferingsSelected(date, recipeName, offeringName)">
                            {{ offeringName }}
                            <span class="text-gray-500 ml-2">({{ Object.keys(items).length }})</span>
                            <span class="ml-2 text-gray-600">
                              <span
                                v-if="isRecipeSiteOfferingCollapsedSelected(date, recipeName, offeringName)">&#9654;</span>
                              <span v-else>&#9660;</span>
                            </span>
                          </td>
                          <td class="text px-6 py-4 text-center">
                            {{ totalYield(items, 'yield_portion') }}
                          </td>
                          <td class="text px-6 py-4 text-center">
                            {{ totalYield(items, 'override_yield_portion') }}
                          </td>
                          <td class="px-6 py-4 whitespace-nowrap font-bold underline id-color text-2xl">
                          </td>
                        </tr>

                        <tr v-show="!isRecipeSiteOfferingCollapsedSelected(date, recipeName, offeringName)"
                          v-for="sresult in items" :key="sresult.id" class="bg-[#ededed]">
                          <!-- <td class="text px-16 py-4">
                            </td> -->
                          <td class="text px-16 py-4">
                            {{ getRecipeSiteOfferName(sresult) }} 
                            <b v-if="sresult.duplicate > 1"> X {{ sresult.duplicate }}</b>
                          </td>
                          <td class="text px-16 py-4">
                            {{ convertDate(sresult.date) }}
                          </td>
                          
                          <td class="text px-16 py-4 text-center">
                            {{ sresult.yield_portion }}
                          </td>
                          <td class="text px-16 py-4">
                            <input type="number" min="0" v-model="sresult.override_yield_portion"
                              class="shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md w-18-input mr-4" />
                          </td>
                          <td class="px-14 py-4 whitespace-nowrap font-bold underline id-color text-2xl">
                            <button @click="removeRecipeFromOrderSelection(sresult)" class="pl-3">
                              <i class="fa fa-trash" aria-hidden="true"></i>
                            </button>
                          </td>
                        </tr>
                        </template>
                      </template>
                    </template>
                  </template>
                </template>
                <!-- </template>
    </template> -->
              </tbody>
              <tbody v-if="searchTableResults.length == 0">
                <tr class="bg-white">
                  <td class="px-6 py-4 whitespace-nowrap text-base text-color text-center" colspan="7">
                    No Selected Recipes Found
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </TableIndexLayout>
  </default-layout>
</template>
<script>
import DefaultLayout from "@/Layouts/DefaultLayout";
import BreadcrumLayout from "@/Pages/Common/Breadcrumbs";
import PageTitleLayout from "@/Pages/Common/PageTitle";
import TableFilterLayout from "@/Pages/Common/TableFilters";
import TableIndexLayout from "@/Pages/Common/TableIndex";
import Paginate from "@/Pages/Partials/Paginate";
import Option from "../MenuCycle/Option.vue";
// import DateRangePicker from 'daterange-picker-vue3';
// import 'daterange-picker-vue3/dist/daterange-picker-vue3.css'
import moment from "moment";
import DatePicker from "../../components/DatePicker.vue";
import vClickOutside from "click-outside-vue3";
import { get } from "jquery";
import { random } from "lodash";

export default {
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: ["sites", "MenuCreationGroup", "orderId"],
  components: {
    DefaultLayout,
    BreadcrumLayout,
    PageTitleLayout,
    TableFilterLayout,
    TableIndexLayout,
    Paginate,
    DatePicker,
    vClickOutside
  },


  data() {
    return {

      sitesOfferingsList: this.transformSites(this.sites),
      sitesOfferingsSelectAll: false,

      // selected recipes for collapse
      collapsedDatesSelected: [], // collapsed date groups
      collapsedRecipesSelected: {},
      collapsedOfferingsSelected: {},

      searched_recipes: [],
      showSearchBoxCancel: false,
      debounce: null,

      // not selected recipes for collapse

      collapsedDates: [], // collapsed date groups
      collapsedRecipes: {},
      collapsedOfferings: {},


      selectAll: false,
      showSite: false,
      showOffeing: false,
      show: { calendar: false },
      headers: [],
      tableData: [],
      todayDt: moment(),
      selectedDate: [moment().subtract(7, "days").startOf("day"), moment().endOf("day")],
      recipes: [],
      searchResults: [],
      searchTableResults: [],
      offerings: [],
      all_offerings: [],
      options: {},
      exportRecipe: [],
      exportRecipeSearced: [],
      exportAssembly: [],
      recipeStudentCount: [],
      recipeCurrentStudentCount: [],
      searchByName: "",
      siteName: [],
      is_data_show: false,
      excludeRecipeIds: [],
      date: {
        startDate: null,
        endDate: null,
      },
      form: {
        date: {
          startDate: null,
          endDate: null,
        },
        site: [],
        offer: [],
        type: "",
        day_id: [],
        name: null
        // sites: [],
      },
      formOld: {
        date: {
        startDate: moment().subtract(7, "days").startOf("day"),
        endDate: moment().endOf("day"),
      },
        site: [],
        offer: [],
        type: "",
        day_id: "",
        sites: [],
      },
      foodOrderForm: this.$inertia.form({
        datas: null
      })
    };
  },
  computed: {

    selectedSitesOfferings: function () {
      this.sitesOfferingsList
        .filter(site => site.selected || site.offerings.some(o => o.selected))
        .map(site => ({
          site: site.name,
          offerings: site.offerings.filter(o => o.selected).map(o => o.name),
        }));
      // this.form.site = [];
      // this.sitesOfferingsList.forEach(site => {
      //   if (site.selected) {
      //     this.form.site.push(site.id);
      //     site.offerings.forEach(o => o.selected = true);
      //   }
      // });
      this.changeSiteOffering();

    },


    getDateRecipe: function () {
      if (
        this.form.date != "" &&
        this.form.site != "" &&
        (this.form.offer != "" || this.form.type == "group")
      ) {
        // this.getDateRecipeData();
        return true;
      } else {
        this.recipes = [];
        return false;
      }
    },

    isAvailableToSendTable2: function () {
      // if checked is true
      return this.searchResults.some((item) => item.is_chekcked);
    },

    groupedResults() {
      const groups = {};
      this.searchResults.forEach((item) => {
        const dateKey = this.convertDate(item.date);
        if (!groups[dateKey]) groups[dateKey] = [];
        groups[dateKey].push(item);
      });
      return groups;
    },
    groupedByDate() {
      const grouped = {};
      // console.log("this.groupedByDate------------", this.searchResults);
      this.searchResults.forEach((item) => {
        const dateKey = this.convertDate(item.date);
        const recipeKey = this.getRecipeName(item.type_number, item.name);
        const offerKey = this.getRecipeSiteOfferName(item, true);

        if (!grouped[dateKey]) grouped[dateKey] = {};
        if (!grouped[dateKey][recipeKey]) grouped[dateKey][recipeKey] = {};
        if (!grouped[dateKey][recipeKey][offerKey]) grouped[dateKey][recipeKey][offerKey] = [];

        grouped[dateKey][recipeKey][offerKey].push(item);

        // grouped[dateKey][recipeKey].push(item);
      });
      console.log("groupedByDate------------", grouped);
      return grouped;
    },
    groupedByDateSelected() {
      const grouped = {};
      this.searchTableResults.forEach((item) => {
        const dateKey = this.convertDate(item.date);
        const recipeKey = this.getRecipeName(item.type_number, item.name);
        const offerKey = this.getRecipeSiteOfferName(item, true);

        if (!grouped[dateKey]) grouped[dateKey] = {};
        if (!grouped[dateKey][recipeKey]) grouped[dateKey][recipeKey] = {};
        if (!grouped[dateKey][recipeKey][offerKey]) grouped[dateKey][recipeKey][offerKey] = [];

        grouped[dateKey][recipeKey][offerKey].push(item);
        // grouped[dateKey][recipeKey].push(item);
      });
      return grouped;
    },

    groupedByRecipeSelected() {
      const grouped = {};
      this.searchTableResults.forEach((item) => {
        // const dateKey = this.convertDate(item.date);
        const recipeKey = this.getRecipeName(item.type_number, item.name);
        const offerKey = this.getRecipeSiteOfferName(item, true);

        // if (!grouped[dateKey]) grouped[dateKey] = {};
        if (!grouped[recipeKey]) grouped[recipeKey] = {};
        if (!grouped[recipeKey][offerKey]) grouped[recipeKey][offerKey] = [];

        grouped[recipeKey][offerKey].push(item);
        // grouped[dateKey][recipeKey].push(item);
      });
      return grouped;
    },

    getGroupByOffering() {
      let sid = this.form.site;
      let sites = [];
      if (sid.length > 0) {
        sid.forEach((element) => {
          let site = this.sites.find((o) => o.id == element);
          if (site) {
            sites.push(site);
          }
        });
      }
      return sites;
    }
  },

  mounted() {
    console.log('mounted-mountedmountedmounted', this.orderId);
    if (this.orderId && this.orderId != null && this.orderId != undefined) {
      console.log('mounted-mountedmountedmounted in ', this.orderId);
      this.getRecipesForFoodOrderEdit();
    }

    if (this.sites.length > 0) {
      this.sites.forEach((element) => {
        this.all_offerings = this.all_offerings.concat(element.offerings);
      })
    }
  },
  methods: {
    changeSiteOffering() {
      console.log("changeSiteOffering called", this.sitesOfferingsList);
      this.form.site = [];
      this.form.offer = [];
      this.sitesOfferingsList.forEach(site => {
        site.is_selected_count = site.offerings.filter(o => o.selected).length;
        site.offerings.forEach(o => {
          if (o.selected) {
            this.form.offer.push(o.id);
            this.form.site.push(site.id);
          }
        });
      });
      console.log("changeSiteOffering end", this.form.site, this.form.offer);
      //setTimeout(() => {
      //  this.getDateRecipeData();
      //}, 500);

    },
    transformSites(apiSites) {
      return apiSites.map(site => ({
        ...site, // keep all original site properties (id, name, etc.)
        selected: false,
        is_selected_count: 0,
        expanded: false,
        offerings: site.offerings.map(offering => ({
          ...offering,
          selected: false
        }))
      }));
    },

    sitesOfferingsAllChecked(items) {
      return items.every(item => item.selected);
    },
    toggleSitesOfferingsSelectAll() {
      this.sitesOfferingsList.forEach(site => {
        site.selected = this.sitesOfferingsSelectAll;
        site.offerings.forEach(o => (o.selected = this.sitesOfferingsSelectAll))
      });

      this.changeSiteOffering();
    },
    toggleSitesOfferingSite(site) {
      site.offerings.forEach(o => (o.selected = site.selected))
      this.sitesOfferingsSelectAll = this.sitesOfferingsList.every(s => s.selected);

      this.changeSiteOffering();
    },
    toggleSitesOfferingItem(site) {
      site.selected = site.offerings.every(o => o.selected)
      this.sitesOfferingsSelectAll = this.sitesOfferingsList.every(s => s.selected);
      this.changeSiteOffering();
    },

    areAllChecked(items) {
      // console.log("areAllChecked", items);
      if (items.length === 0) return false;
      return items.every(i => i.is_chekcked);
    },

    areAllRecipeItemsChecked(offerGroups) {
      const allItems = Object.values(offerGroups).flat();
      return allItems.length > 0 && allItems.every(i => i.is_chekcked);
    },

    // ✅ Toggle all sub-items when main checkbox changes
    toggleAll(items, event) {
      const checked = event.target.checked;
      items.forEach(i => {
        i.is_chekcked = checked;
      });
    },

    toggleAllRecipeItems(offerGroups, event) {
      const checked = event.target.checked;
      Object.values(offerGroups).flat().forEach(item => {
        item.is_chekcked = checked;
      });
    },

    toggleAllRecipeSiteOfferingItems(items, event) {
      const checked = event.target.checked;
      items.forEach(item => {
        item.is_chekcked = checked;
      });
    },

    totalYield(items, fname) {
      return items.reduce((sum, item) => sum + Number(item[fname] || 0), 0);
    },

    totalRecipeYield(offerGroups, fname) {
      return Object.values(offerGroups).reduce((sum, items) => {
        return sum + items.reduce((s, item) => s + Number(item[fname] || 0), 0);
      }, 0);
    },

    totalItemsInOfferGroups(offerGroups) {
      return Object.values(offerGroups).reduce((sum, items) => {
        return sum + items.length;
      }, 0);
    },

    toggleDate(date) {
      const i = this.collapsedDates.indexOf(date);
      if (i > -1) this.collapsedDates.splice(i, 1);
      else this.collapsedDates.push(date);
    },
    toggleRecipe(date, recipe) {

      if (!this.collapsedRecipes[date]) {
        this.collapsedRecipes = { ...this.collapsedRecipes, [date]: [] };
      }
      const arr = this.collapsedRecipes[date];
      const i = arr.indexOf(recipe);
      if (i > -1) arr.splice(i, 1);
      else arr.push(recipe);
    },

    toggleRecipeSiteOfferings(date, recipeName, offering) {
      if (!this.collapsedOfferings[date]) {
        this.collapsedOfferings = { ...this.collapsedOfferings, [date]: {} };
      }
      if (!this.collapsedOfferings[date][recipeName]) {
        this.collapsedOfferings[date][recipeName] = [];
      }
      const arr = this.collapsedOfferings[date][recipeName];
      const i = arr.indexOf(offering);
      if (i > -1) arr.splice(i, 1);
      else arr.push(offering);
    },

    toggleRecipeSiteOfferingsSelected(date, recipeName, offering) {
      if (!this.collapsedOfferingsSelected[date]) {
        this.collapsedOfferingsSelected = { ...this.collapsedOfferingsSelected, [date]: {} };
      }
      if (!this.collapsedOfferingsSelected[date][recipeName]) {
        this.collapsedOfferingsSelected[date][recipeName] = [];
      }
      const arr = this.collapsedOfferingsSelected[date][recipeName];
      const i = arr.indexOf(offering);
      if (i > -1) arr.splice(i, 1);
      else arr.push(offering);
    },


    isRecipeCollapsed(date, recipe) {
      return this.collapsedRecipes[date]?.includes(recipe);
    },

    // isRecipeSiteOfferingCollapsed(site, recipeName, offering) {
    //     return (
    //         this.collapsedOfferings[site] &&
    //         this.collapsedOfferings[site][recipeName] &&
    //         this.collapsedOfferings[site][recipeName].includes(offering)
    //     );
    // },

    isRecipeSiteOfferingCollapsed(date, recipeName, offeringName) {
      return (
        this.collapsedOfferings[date]?.[recipeName]?.includes(offeringName) || false
      );
    },

    collapsedRecipes(searchResults) {
      searchResults.forEach((item) => {
        const dateKey = this.convertDate(item.date);
        if (!this.collapsedDates.includes(dateKey)) {
          this.collapsedDates.push(dateKey);
        }
      });
    },



    // selected
    toggleDateSelected(date) {
      const i = this.collapsedDatesSelected.indexOf(date);
      if (i > -1) this.collapsedDatesSelected.splice(i, 1);
      else this.collapsedDatesSelected.push(date);
    },
    toggleRecipeSelected(date, recipe) {

      if (!this.collapsedRecipesSelected[date]) {
        this.collapsedRecipesSelected = { ...this.collapsedRecipesSelected, [date]: [] };
      }
      const arr = this.collapsedRecipesSelected[date];
      const i = arr.indexOf(recipe);
      if (i > -1) arr.splice(i, 1);
      else arr.push(recipe);
    },
    isRecipeCollapsedSelected(date, recipe) {
      return this.collapsedRecipesSelected[date]?.includes(recipe);
    },

    isRecipeSiteOfferingCollapsedSelected(site, recipeName, offering) {
      return (
        this.collapsedOfferingsSelected[site] &&
        this.collapsedOfferingsSelected[site][recipeName] &&
        this.collapsedOfferingsSelected[site][recipeName].includes(offering)
      );

    },

    getFirstRecipeId(offerGroups) {
      const firstOfferItems = Object.values(offerGroups)[0];
      return firstOfferItems && firstOfferItems[0] ? firstOfferItems[0].recipe_id : null;
    },

    getRecipesForFoodOrderEdit() {
      console.log('getRecipesForFoodOrderEdit in ', this.orderId);
      axios.post(route('edit-food-order-calculator', this.orderId))
        .then((response) => {
          console.log("edit-food-order-calculator", response.data);
          let data = response.data;
          let recipes = [];
          if (response.data.length > 0) {
            console.log('getRecipesForFoodOrderEdit total length', response.data);
            recipes = response.data;
            data.forEach(element => {
              this.excludeRecipeIds.push(element.id);
            })
          }

          this.searchTableResults = recipes;

        })
        .catch(error => console.error(error));
    },

    getRecipeName(type_number, name) {
      return name;
    },

    recipeSearchData() {

      if (this.form.name == '') {
        this.searched_recipes = [];
        return;
      }

      clearTimeout(this.debounce);

      this.debounce = setTimeout(() => {
        axios.post('/recipe-search-filter', { type: 'search', search: this.form.name, excludeRecipeIds: this.excludeRecipeIds })
          .then((response) => {
            console.log("recipe-search-filter", response.data.data);
            let data = response.data.data;
            let recipes = [];
            if (response.data.total > 0) {
              data.forEach(element => {
                recipes.push({
                  'oc_id': Math.floor(Math.random() * 1000),
                  'recipe_id': element.id,
                  'name': element.name,
                  'type_number': element.type_number,
                  'yield_portion': element.portion,
                  'override_yield_portion': null,
                  'date': null,
                  'is_chekcked': false,
                  'site_id': null,
                  'offer_id': null,
                  'extra_product': false
                });
              })
            }

            // this.recipes = [];
            if (this.form.name != '') {
              this.searched_recipes = recipes;
            }

            // this.getSearchRecipeStudentCount();

          })
          .catch(error => console.error(error));

      }, 900);
    },

    triggerFileUpload() {
      this.$refs.fileInput.click();
    },

    pushOrder() {
      // console.log('searchTableResults', this.searchTableResults);
      this.foodOrderForm.datas = this.searchTableResults;
      console.log("this.foodOrderForm.datas", this.foodOrderForm.datas);
      this.hideShowLoader('show');
      axios.post(this.route('save-food-order-calculator'), { datas: this.foodOrderForm.datas, orderId: this.orderId })
        .then((response) => {
          this.hideShowLoader('hide');
          if (!response.data.status) {
            console.log("error ", response.data.message);
            this.$toast.error(response.data.message);
          } else {
            this.$toast.success(response.data.message);
            if (response.data.is_updated) {
              window.location.href = this.route('foodorder-detail-edit-step3') + '?' + 'order_id=' + response.data.order_id;
            } else {
              window.location.href = this.route('foodorder-detail-edit-step3') + '?' + 'order_id=' + response.data.order_id;
            }
          }
          console.log("response", response);
        });
      // this.foodOrderForm.post(this.route('save-food-order-calculator'), {
      //   onSuccess: () => {
      //     this.$toast.success('Food Order Added Successfully!');
      //   },
      // });
    },
    closeSite() {
      this.showSite = false;

    },
    closeOffering() {
      this.showOffeing = false;
    },
    showCalendar() {
      this.show.calendar = !this.show.calendar;
      if (!this.show.calendar) {
        // selectedDate
        console.log("selectedDate", this.selectedDate[0].format('YYYY/MM/DD'));
        this.changeDate(true);
      }
      // console.log("showCalendar", this.show.calendar);
    },

    generateRandom(len = 10) {
      return Math.random().toString(36).substring(2, 2 + len);
    },

    removeExtraRecipeFromOrderSelection() {
      const map = {};

    this.searchTableResults.forEach(item => {
      const key = `${item.offer_id}_${item.recipe_id}_${item.date}`;
      if(item.duplicate === undefined)
      {
        item.duplicate = 1;
      }
       // optional: store the key for reference

      if (!map[key]) {
        // clone object to avoid reference issues
        map[key] = { ...item };
        map[key].yield_portion = Number(item.yield_portion) || 0;
        map[key].override_yield_portion = Number(item.override_yield_portion) || 0;
      } else {
        map[key].yield_portion += Number(item.yield_portion) || 0;
        map[key].override_yield_portion += Number(item.override_yield_portion) || 0;
        map[key].duplicate += 1;
      }
    });

    // return unique records
    this.searchTableResults = Object.values(map);
    },

    setOnTable2() {
      // search results to get only checked data and merge in searchTableResults then remove form search result
      let a = this.searchResults.filter(
        (item) => item.is_chekcked
      );

      a.map((item) => {
        item.temp_id = this.generateRandom();
        return item;
      });

      console.log("a", a);
      // merge new data
      this.searchTableResults = this.searchTableResults.concat(a);

      this.searchResults = this.searchResults.filter(
        (item) => !item.is_chekcked
      );
      this.removeExtraRecipeFromOrderSelection();

      // Object.entries(this.groupedByDateSelected).forEach(([date, recipesByDate]) => {
      //   this.collapsedRecipesSelected[date] = Object.keys(recipesByDate);

      //   if (!this.collapsedOfferingsSelected[date]) {
      //     this.collapsedOfferingsSelected[date] = {};
      //   }

      //   Object.entries(recipesByDate).forEach(([recipeName, offerGroups]) => {
      //     this.collapsedOfferingsSelected[date][recipeName] = Object.keys(offerGroups);
      //   });
      // });
    },

    removeRecipeFromOrderSelection(r) {
      console.log("removeRecipeFromOrderSelection", r, this.searchTableResults);
      this.searchTableResults = this.searchTableResults.filter(
        (item) => item.temp_id != r.temp_id
      );
      r.is_chekcked = false;
      this.searchResults.push(r);
      //for same position
      // this.searchResults.splice(r.originalIndex, 0, r);
      //end for same position
    },



    addZero(v) {
      if (v < 10) {
        v = `0${v}`;
      }
      return v;
    },

    convertDate(date) {
      // return date?.split("-").reverse().join("-");
      if (!date) return '-'; // handle null or empty date safely

      const parsedDate = new Date(date);
      if (isNaN(parsedDate)) return '-'; // handle invalid date

      return parsedDate.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });

    },

    changeDate(isRender) {
      if (this.selectedDate[0]) {
        this.form.date.startDate = this.selectedDate[0].format('YYYY/MM/DD');
        this.form.date.endDate = this.selectedDate[1].format('YYYY/MM/DD');
        if (isRender) {
          //this.getDateRecipeData();
        }
      }
    },
    updateDatePicker(value) {
      console.log("updating datepicker value", value);
      // this.datepicker = value;
    },

    showCount(sc) {
      if (isNaN(sc)) {
        return "N/A";
      } else if (sc >= 1) {
        return sc;
      } else if (sc === 0) {
        return 0;
      } else {
        return "N/A";
      }
    },

    resetSeatch() {
      this.form = {
        date: {
          startDate: null,
          endDate: null,
        },
        site: [],
        offer: [],
        type: "",
        day_id: "",
        sites: [],
      };
      this.formOld = {
        date: {
          startDate: null,
          endDate: null,
        },
        site: [],
        offer: [],
        type: "",
        day_id: "",
        sites: [],
      };
      this.date = {
        startDate: null,
        endDate: null,
      };
      this.recipes = [];
      this.searchResults = [];
      this.offerings = [];
      this.options = {};
      this.exportRecipe = [];
      this.exportRecipeSearced = [];
      this.exportAssembly = [];
      this.recipeStudentCount = [];
      this.searchByName = "";

      this.sitesOfferingsSelectAll = false;
      this.toggleSitesOfferingsSelectAll();
    },

    showSiteName(sid) {

      // if (this.form.type == "group") {
      //   return this.MenuCreationGroup.find((e) => e.id == sid).name;
      // }
      // if (this.form.type == "site") {
      return this.sites.find((e) => e.id == sid).name;
      // }
    },

    showOfferName(oid) {
      let name = '';
      this.sites.forEach((element) => {
        element.offerings.forEach((offering) => {
          if (offering.id == oid) {
            name = offering.name + " (" + element.name + ")";
          }
        });
      })
      return name;
    },

    cancelSearch() {
      this.form = Object.assign({}, this.formOld);
      this.selectedDate =[moment( this.formOld.date.startDate), moment( this.formOld.date.endDate)];
      this.form.site = [];
      this.form.offer = [];
      console.log("cancelSearch form", this.formOld.offer, this.sitesOfferingsList);
      this.sitesOfferingsList.forEach(site => {        
        site.offerings.forEach(o => {
          if(this.formOld.offer.includes(o.id)){
            o.selected = true;
          } else {
            o.selected = false;
          }
          if (o.selected) {
            this.form.offer.push(o.id);
            this.form.site.push(site.id);
          }
        });
        console.log("cancelSearch site in", site.offerings);
        site.selected = site.offerings.every(o => o.selected);
        site.is_selected_count = site.offerings.filter(o => o.selected).length;
      });
      console.log("cancelSearch form end", this.sitesOfferingsList);
    },

    getDateRecipeData() {
      // clearTimeout(this.debounce);
      console.log("getDateRecipeData form", this.form);
      this.formOld = Object.assign({}, this.form);
      console.log("getDateRecipeData formOld", this.formOld);
      // this.debounce = setTimeout(() => {
        this.changeDate(false);
        this.searchResults = [];
        if (
          this.form.date.startDate && this.form.date.startDate != "" &&
          this.form.site != "" &&
          (this.form.offer != "" || this.form.type == "group")
        ) {
          let $this = this;

          this.hideShowLoader('show');
          axios
            .get(this.route("get-order-calculator-report-data", this.form))
            .then((response) => {

              $this.form.day_id = [];
              console.log("response.data", response.data);
              $this.hideShowLoader('hide');
              if (response.data.status) {
                $this.searchResults = this.removeDuplicateRecipes(response.data.data); // response.data.data;
                // $this.searchResults = response.data.data; // response.data.data;

                Object.entries($this.groupedByDate).forEach(([date, recipesByDate]) => {
                  this.collapsedRecipes[date] = Object.keys(recipesByDate); // collapse all recipe names

                  if (!this.collapsedOfferings[date]) {
                    this.collapsedOfferings[date] = {};
                  }

                  Object.entries(recipesByDate).forEach(([recipeName, offerGroups]) => {
                    this.collapsedOfferings[date][recipeName] = Object.keys(offerGroups);
                  });
                });
                // $this.searchResults.forEach((element) =>
                //   $this.form.day_id.push(element.id)
                // );
                // console.log("form.day_id", $this.form.day_id);
              } else {
                $this.form.day_id = [];
              }
            })
            .catch((error) => console.error(error));
        }

      // }, 1000);
    },
    removeDuplicateRecipes(arr) {
      // remove duplicate recipe based on recipe_id and date and offer_id and add duplicate column to increment
      const result = [];
      const uniqueMap = new Map();
      arr.forEach(item => {
        const key = `${item.recipe_id}-${item.date}-${item.offer_id}`;
        if (!uniqueMap.has(key)) {
          uniqueMap.set(key, { ...item, duplicate: 1 });
          result.push(uniqueMap.get(key));
        } else {
          const existingItem = uniqueMap.get(key);
          existingItem.duplicate++;
        }
      });
      return result;
    },

    getOffering() {
      this.form.day_id = [];
      var options = event.target.options;
      console.log("options", options);
      var type = "";
      // if (options.selectedIndex > -1) {
      //   // type = options[options.selectedIndex].getAttribute("type");
      //   // console.log("type ", type);
      // }
      this.form.type = type;
      console.log("this.form", this.form);

      let sid = this.form.site;
      this.offerings = [];
      if (sid.length > 0) {
        sid.forEach((element) => {
          let site = this.sites.find((o) => o.id == element);
          if (site) {
            console.log("getOffering", this.offerings.concat(site.offerings));
            this.offerings = this.offerings.concat(site.offerings);
          }
        });
      }

      this.form.offer = this.form.offer.filter(item => this.offerings.find(o => o.id == item));

    },

    exportToCSV() {
      // Define CSV headers
      const headers = ["ID", "Date of Order", "Recipe Type Name", 'Planned Headcount', 'Override Headcount'];

      // Combine headers with data rows
      const rows = [
        headers.join(","), // Join headers as CSV
        ...this.searchTableResults.map((row) =>
          [row.temp_id, row.date, row.name, row.yield_portion, row.override_yield_portion].join(",")
        ),
      ];

      // Convert rows to a single string with line breaks
      const csvContent = rows.join("\n");

      // Create a Blob from the CSV content
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);

      // Create a link element for the download
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "data.csv");
      document.body.appendChild(link);

      // Programmatically trigger the download and clean up
      link.click();
      document.body.removeChild(link);
    },
    importCSV(event) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();

      reader.onload = (e) => {
        const csvContent = e.target.result;

        // Parse CSV content
        const rows = csvContent.split("\n").filter((row) => row.trim() !== "");
        // this.headers = rows[0].split(",").map((header) => header.trim());
        let tableData = rows.slice(1).map((row) => row.split(",").map((cell) => cell.trim()));

        // replace the override_yield_portion in searchTableResults with tableData via id
        this.searchTableResults.forEach((element) => {
          tableData.forEach((row) => {
            if (element.temp_id == row[0]) {
              element.override_yield_portion = row[4];
            }
          });
        });



        // console.log("headers", headers);
        // console.log("tableData", tableData);
      };

      reader.readAsText(file);
    },
    hideShowLoader(types) {
      if (types == 'show') {
        document.getElementById('full_loader').style.display = 'flex';
      } else {
        document.getElementById('full_loader').style.display = 'none';
      }
    },
    selectAllRecipe() {
      if (this.selectAll) {
        this.searchResults.forEach((item) => {
          item.is_chekcked = true;
        });
      } else {
        this.searchResults.forEach((item) => {
          item.is_chekcked = false;
        });
      }
    },

    getRecipeSiteOfferName(recipe, isSimpleName = false) {
      if (recipe.offer_id == null || recipe.site_id == null) return '';
      let rid = recipe.site_id;
      let oid = recipe.offer_id;
      let siteName = this.sites.find((e) => e.id == rid)?.name || '';
      let offerName = this.all_offerings.find((e) => e.id == oid)?.name || '';
      if (isSimpleName) return siteName + ' - ' + offerName;
      return siteName + ' - ' + offerName;
      // return '- ('+ siteName + ' - ' + offerName + ')';
    },
    cancelRecipeSearchValue() {
      this.form.name = "";
      this.searched_recipes = [];
      this.showSearchBoxCancel = false;
    },
    selectRecipesIdToAdd(recipeObj) {
      recipeObj.is_chekcked = true;
      recipeObj.date = new Date().toISOString().split('T')[0];
      recipeObj.temp_id = this.generateRandom();
      this.searchTableResults.push(recipeObj);
      this.cancelRecipeSearchValue();
    },

    removeOffering(offerId) {
      this.sitesOfferingsList.map(site => {
        site.offerings.map(o => {
          if (o.id === offerId) {
            o.selected = false;
            this.toggleSitesOfferingItem(site);
          }
        });
      });
      // this.form.offer = this.form.offer.filter(id => id !== offerId);
      // this.changeSiteOffering();
    },

  },
};
</script>
<style>
.id_arrow .fa-sort-desc:before {
  content: "\f0dd";
  position: absolute;
  top: 17px;
  left: 43px;
  padding-left: 7px;
  color: #219fd5;
}

select.select_menu_height {
  height: 2.3rem !important;
}

.select_menu_height {
  height: 2.3rem !important;
}

.select_menu_height i.fa.fa-sort-desc {
  position: relative;
  top: -4px;
}

.id_arrow .fa-sort-asc:before {
  content: "\f0de";
  color: #219fd5;
  padding-left: 7px;
  position: absolute;
  top: 17px;
  left: 43px;
}

.max-height-screen {
  max-height: calc(100vh - 380px);
}

.trim_text {
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 250px;
}

.tooltip {
  display: inline-block;
  position: relative;
  text-align: left;
}

.tooltip .top {
  width: 250px;
  top: 50%;
  left: 100%;
  margin-left: 20px;
  transform: translate(0, -50%);
  padding: 5px 10px;
  color: #444444;
  background-color: #eeeeee;
  font-weight: normal;
  font-size: 14px;
  border-radius: 5px;
  position: absolute;
  z-index: 99999999;
  box-sizing: border-box;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.5);
  display: none;
  white-space: normal;
}

.tooltip:hover .top {
  display: block;
}

.tooltip .top i {
  position: absolute;
  top: 50%;
  right: 100%;
  margin-top: -12px;
  width: 12px;
  height: 24px;
  overflow: hidden;
}

.tooltip .top i::after {
  content: "";
  position: absolute;
  width: 12px;
  height: 12px;
  left: 0;
  top: 50%;
  transform: translate(50%, -50%) rotate(-45deg);
  background-color: #eeeeee;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.5);
}

.cart-color {
  color: #f7a53a;
}

.name_list {
  display: none;
}

.onhover:hover .name_list {
  display: block;
}

table.min-w-full tr:last-child .name_list {
  top: auto;
  bottom: 32px;
}

.vue-daterange-picker {
  width: 100%;
  display: block !important;
}

.vue-daterange-picker .form-control.reportrange-text {
  --tw-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000),
    var(--tw-shadow);
  border-radius: 0.5rem;
  --tw-border-opacity: 1;
  border-color: rgba(209, 213, 219, var(--tw-border-opacity));
}

@media screen and (min-width: 768px) {

  .daterangepicker.show-ranges.show-weeknumbers,
  .daterangepicker.show-ranges {
    min-width: 683px !important;
  }
}
</style>
<style scoped>
label {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  cursor: pointer;
}

pre {
  background: #f8f8f8;
  padding: 0.5rem;
  margin-top: 1rem;
  border-radius: 6px;
}
</style>
